var _rect, _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgStandby = function SvgStandby(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 15,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_381_221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-31 -64H263V215C263 219.418 259.418 223 255 223H-23C-27.4183 223 -31 219.418 -31 215V-64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -13,
    y: -8,
    width: 108,
    height: 32,
    rx: 16,
    fill: "#FFF9D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.76993 0.5H6.21647V8.2673H7.76993V0.5ZM11.5215 2.1855L10.4186 3.28846C11.0467 3.79399 11.5534 4.4339 11.9015 5.16111C12.2497 5.88831 12.4304 6.68432 12.4303 7.49057C12.4303 8.93258 11.8575 10.3155 10.8378 11.3352C9.81816 12.3548 8.43521 12.9277 6.9932 12.9277C5.871 12.9284 4.77612 12.5815 3.85898 11.9348C2.94185 11.2882 2.24745 10.3733 1.8712 9.3161C1.49495 8.25885 1.4553 7.11104 1.75771 6.03035C2.06011 4.94966 2.68973 3.98912 3.56006 3.28069L2.46487 2.1855C1.76499 2.78007 1.1891 3.5067 0.770103 4.32389C0.351107 5.14107 0.0972104 6.03279 0.0229167 6.94812C-0.0513771 7.86345 0.0553876 8.78444 0.337112 9.6585C0.618837 10.5326 1.07 11.3426 1.66483 12.0422C4.1659 14.9782 8.57773 15.3355 11.5215 12.8345C12.2956 12.1761 12.9168 11.357 13.3421 10.4341C13.7673 9.51119 13.9863 8.50671 13.9838 7.49057C13.9838 5.44777 13.0828 3.50594 11.5215 2.1855Z",
    fill: "#F4C51F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_381_221"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 294,
    height: 287,
    fill: "white",
    transform: "translate(-31 -64)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStandby, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/standby.35c94f67.svg";
export { ForwardRef as ReactComponent };